/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ion-list[_ngcontent-%COMP%]{width:100%}.defect-row[_ngcontent-%COMP%]{display:-webkit-box;display:flex;margin-bottom:16px}.c-defect-cancel[_ngcontent-%COMP%]{width:480px;margin:40px auto}.note-field[_ngcontent-%COMP%]{width:100%;margin-bottom:10px;position:relative}.note-field--input[_ngcontent-%COMP%]{border-radius:15px;background-color:#fff;border:1px solid rgba(0,0,0,.2);margin-bottom:5px;outline:0;padding:10px;width:100%;line-height:1rem;font-size:1rem;min-height:6rem;max-height:10rem;resize:none}"];
export { styles as styles };
